import { render, staticRenderFns } from "./ConventionalImageWithWireframe.vue?vue&type=template&id=b0ea4ed0&"
import script from "./ConventionalImageWithWireframe.vue?vue&type=script&lang=js&"
export * from "./ConventionalImageWithWireframe.vue?vue&type=script&lang=js&"
import style0 from "./ConventionalImageWithWireframe.vue?vue&type=style&index=0&id=b0ea4ed0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports